<template>
  <div class="sp_test">
    <sp-table :tableParams="tableParams"></sp-table>
  </div>
</template>

<script>
import spTable from '../../components/table/spTable.vue'
export default {
  components: { spTable },
  name: 'spTest',
  data () {
    return {
      tableParams: {
        tableRow: [
          //label表头标题、prop表格的内容，与tableData的字段名对应、width对应列的宽度、sortable是否需要排序、showOverflowTooltip是否内容过长被隐藏时显示tooltip、
          //fixed固定对应列，可选left或right、colFunction对应列是否需要点击事件、handleColum列的点击事件
          { label: 'Case ID', prop: "caseNo", sortable: false, showOverflowTooltip: false, fixed: false, colFunction: true, handelColum: (row) => { this.handelCaseNo(row) } },
          { label: 'Customer', prop: "customer", sortable: false, width: 120, },
          { label: 'Product', prop: "product", sortable: false, },
          { label: 'Title', prop: "title", sortable: false, },
          { label: 'Submit by', prop: "Submit by", sortable: false, },
        ],
        tableData: [
          { caseNo: "202203112001", customer: 'test', product: "SCP", title: 'This is a test', 'Submit by': "Niko" },
          { caseNo: "202203112001", customer: 'test', product: "SCP", title: 'This is a test', 'Submit by': "Niko" },
        ],
        //表格操作按钮
        operationData: {
          defaultBtn: [
            { label: "Update", handelOpration: (row) => { this.handelUpdate(row) } }
          ],
          dropdownBtn: {
            handelcommand: (row) => { this.handelDropdown(row) },
            option: [
              { id: 1, label: 'Download' },
              { id: 2, label: 'Delete' },
            ]
          }
        },
        selectionChange: (row) => { this.tableSelection(row) },//勾选多选框的回调函数
        disabledSelection: (row, index) => { this.banSelection(row) },
        height: '',//表格高度 不需要可以不传
        maxHeight: '900px',//表格最大高度 不需要可以不传
        stripe: true,//是否需要斑马纹 不需要可以不传
        selection: true,//是否需要多选框 不需要可以不传
        border: true,//是否需要边框 不需要可以不传
        size: 'small',//medium / small / mini,默认small 不需要可以不传
        heightAlign: 'left',//表头对其方式left/center/right 不需要可以不传
        align: 'left',//表格内容对其方式left/center/right 不需要可以不传
        operation: true,//是否需要操作列
        operationLabel: 'Operation',//操作列表头名
      }
    }
  },

  methods: {
    handelCaseNo (data) {
      console.log(data);
    },

    handelUpdate (data) {
      console.log(data);
    },

    handelDropdown (data) {
      console.log(666);
      console.log(data);
    },

    tableSelection (data) {
      console.log(data);
    },

    banSelection (data) {
      if (data.product == "SCP") {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style>
</style>